module.exports = __webpack_public_path__ + "static/img/朴坊.556f464d.png";